import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage'; // Nuevo componente para manejar la navegación
import Login from './components/Login';
import Register from './components/Register';
import BeOne from './components/BeOne';
import Contact from './components/Contact';
import ServiceLink from './components/ServiceLink';
import UserSelection from './components/UserSelection';

function App() {
  return (
    <Router>
      <div className="App local-hire-design">
        <div className="decorative-line top-line"></div>
        <div className="decorative-line bottom-line"></div>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/beone" element={<BeOne />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/servicelink" element={<ServiceLink />} />
          <Route path="/user-selection" element={<UserSelection />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
